import type { ArbitraryTypedObject } from '@portabletext/types';
import { PortableTextBlock } from '@sanity/types';
import { PortableTextWrapper } from './PortableTextWrapper';
import Image from 'next/image';
import { getSanityImageUrl } from '@/libs/sanity/client';
import { BlurInH2 } from '@/components/eldora-ui/blur-in-h2';
import { MOBILE_SCREEN_SIZE } from '@/utils/constants';
import { useMediaQuery } from 'usehooks-ts';

type TextImageProps = {
  anchor?: string;
  title?: string;
  bottomImage: any;
  text:
    | (PortableTextBlock | ArbitraryTypedObject)
    | (PortableTextBlock | ArbitraryTypedObject)[];
  textForMobile?:
    | (PortableTextBlock | ArbitraryTypedObject)
    | (PortableTextBlock | ArbitraryTypedObject)[];
};

const TwoTextColumns = ({
  anchor,
  text,
  textForMobile,
  title,
  bottomImage,
}: TextImageProps) => {
  const isMobile = useMediaQuery(`(max-width: ${MOBILE_SCREEN_SIZE}px)`);

  return (
    <section id={anchor} className="w-full mt-12 scroll-mt-[150px]">
      {title && <BlurInH2>{title}</BlurInH2>}
      {isMobile ? (
        <div className="w-full xl:max-w-4xl">
          {textForMobile ? (
            <PortableTextWrapper value={textForMobile} />
          ) : (
            <PortableTextWrapper value={text} />
          )}
        </div>
      ) : (
        <div className="w-full xl:max-w-4xl">
          {text && <PortableTextWrapper value={text} />}
        </div>
      )}
      {bottomImage && (
        <div className="w-full mt-8">
          <Image
            src={getSanityImageUrl(bottomImage)}
            alt="Image"
            className="h-full object-cover w-full"
            loading="lazy"
            width="1440"
            height="567"
          />
        </div>
      )}
    </section>
  );
};

export default TwoTextColumns;
